// Norm[0,1] -> engineering units mapping (writes ParameterState.units).

import type { ParameterState } from '@shared/parameterState';

function logMap(n: number, min: number, max: number): number {
  return min * Math.pow(max / min, n);
}
function linMap(n: number, min: number, max: number): number {
  return min + (max - min) * n;
}

export function unitFromNorm(axis: keyof ParameterState['norm'], n: number): number {
  switch (axis) {
    case 'density':
      return logMap(n, 2, 40);
    case 'register':
      return logMap(n, 110, 880);
    case 'brightness':
      return linMap(n, -1, 1);
    case 'harmonicity':
      return logMap(n, 0.0001, 0.02);
    case 'space':
      return linMap(n, 0, 1);
  }
}

/** Fill state.units in place from state.norm. */
export function fillUnits(state: ParameterState): void {
  state.units.densityOnsetsPerMin = unitFromNorm('density', state.norm.density);
  state.units.registerCentroidHz = unitFromNorm('register', state.norm.register);
  state.units.brightnessTilt = unitFromNorm('brightness', state.norm.brightness);
  state.units.harmonicityB = unitFromNorm('harmonicity', state.norm.harmonicity);
  state.units.spaceReverb = unitFromNorm('space', state.norm.space);
}
